import { reactive } from 'vue';
import api from '@/api/index';

const member = reactive({
  info: {},
  jwt: '',
  deviceToken: '',
  os: '',
  initialize,
  updateInfo,
  changeClinic,
});

async function initialize() {
  await getInfo(member.deviceToken);
}

async function getInfo(deviceToken) {
  const response = await api.auth.verify(deviceToken);

  updateInfo(response);
  member.jwt = response.jwt;
}

function updateInfo(response) {
  member.info = response.member;
}

function changeClinic() {
  if (member.info.clinic === '璟馨') member.info.clinic = '詠馨';
  else member.info.clinic = '璟馨';
}

export default member;
